import { InjectionToken } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';

export const NAVIGATION_CONFIG = new InjectionToken('NAVIGATION_CONFIG', {
  factory: (): FuseNavigationItem[] => [
    {
      type: 'divider',
    },
    {
      id: 'Home',
      type: 'basic',
      title: 'MENU.HOME',
      link: '',
      icon: 'heroicons_outline:home',
    },
    {
      type: 'divider',
    },
    {
      id: 'tasks',
      title: 'MENU.TASKS',
      type: 'collapsable',
      icon: 'heroicons_outline:briefcase',
      children: [
        {
          id: 'new-task-form',
          title: 'MENU.CREATE_TASK',
          type: 'basic',
          link: '/tasks/form',
        },
        {
          id: 'task-list',
          type: 'basic',
          title: 'MENU.TASK_LIST',
          exactMatch: true,
          link: '/tasks',
        },
        {
          id: 'configure-tasks',
          title: 'MENU.CONFIGURE_TASK_SECTIONS',
          exactMatch: true,
          type: 'basic',
          link: '/tasks/configure',
        },
        {
          id: 'status-graph',
          title: 'MENU.STATUS_GRAPH',
          exactMatch: true,
          type: 'basic',
          link: '/tasks/status-graph',
        },
        {
          id: 'task-locations',
          title: 'MENU.TASK_LOCATIONS',
          exactMatch: true,
          type: 'basic',
          link: '/tasks/details/locations',
        },
      ],
    },

    {
      id: 'checklists',
      title: 'MENU.CHECKLISTS',
      type: 'collapsable',
      icon: 'heroicons_outline:check-circle',
      children: [
        {
          id: 'checklist',
          title: 'MENU.CHECKLISTS',
          type: 'basic',
          link: '/checklists',
        },
      ],
    },
    {
      id: 'assets',
      title: 'MENU.ASSETS',
      type: 'basic',
      icon: 'mat_solid:home_repair_service',
      link: '/assets',
    },
    {
      id: 'locations',
      title: 'MENU.LOCATIONS',
      type: 'basic',
      icon: 'mat_solid:location_on',
      link: '/locations',
    },
    {
      id: 'plans',
      title: 'MENU.PLANS',
      type: 'basic',
      icon: 'heroicons_outline:map',
      link: '/plans',
    },
  ],
});
